import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  AddMMPLUserDetails,
  getMMPLUsersList,
} from "../Actions/UserManagementAPI";
import { getSpecialAccessUsersList } from "../Actions/SpecialAccessUserManagementAPI";
import { getShipnameList } from "../Actions/HelpersAPI";
import { Multiselect } from "multiselect-react-dropdown";
import swal from "sweetalert";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";

let searchData = {
  Mail: "",
  IsAdmin: false,
  PageNumber: 1,
  PageSize: 25,
};
let userkey = JSON.parse(localStorage.getItem("currentUser"));
class AddUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      emailId: "",
      isAdmin: false,
      ships: [],
      createdBy: userkey.name,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    this.SubmitData = this.SubmitData.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onRemoveChange = this.onRemoveChange.bind(this);
  }
  componentDidMount() {
    this.props.dispatch(getShipnameList());
    // this.props.dispatch(getMMPLUsersList(searchData));
  }
  handleInputChange(e) {
    this.state.emailId = e.target.value;
    this.setState({});
  }

  handleCheckBoxChange(e) {
    if (e.target.checked) {
      this.setState({
        isAdmin: true,
      });
    } else {
      this.setState({
        isAdmin: false,
      });
    }
  }
  handleCheckBoxChange1(e) {
    if (e.target.checked) {
      this.setState({
        isAdmin: false,
      });
    } else {
      this.setState({
        isAdmin: true,
      });
    }
  }

  SubmitData() {

    const { UsersList, dispatch } = this.props;
    // let user = UsersList ? UsersList.users.filter(r => { return r.emailId === this.state.emailId }) : '';

    // let userinfo = {
    //   email: this.state.emailId,
    //   isAdmin: this.state.isAdmin,
    //   mmplShips: this.state.ships ? this.state.ships.map(item => item.shipName).toString() : "",
    //   createdBy: "",
    // };

    let userinfo = {};

    if (this.props.isSpecial) {
      userinfo = {
        email: this.state.emailId,
        name: this.state.emailId,
        ships: this.state.ships ? this.state.ships.map(item => item.shipName).toString() : "",
        createdBy: "",
      };
    } else {
      userinfo = {
      email: this.state.emailId,
      isAdmin: this.state.isAdmin,
      mmplShips: this.state.ships ? this.state.ships.map(item => item.shipName).toString() : "",
      createdBy: "",
      };
    }


    if (this.state.emailId !== "") {
      let emailregex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (emailregex.test(this.state.emailId)) {
        let url2 = `${API.userExist}?Mail=${this.state.emailId}`;
        axios
          .get(url2, {
            headers: {
              key: userkey.accessToken,
            },
          })
          .then((response) => {
            if (response.data === true) {
              let url = "";
              if (this.props.isSpecial) {
                url = API.AddSpecialAccessUser
              } else {
                url = API.PostMmplUser
              }
              axios
                .post(url, userinfo, {
                  headers: {
                    key: userkey.accessToken,
                  },
                })
                .then((response) => {
                  if (response.status === 500) {
                    swal("Error!", "Error when adding the data. Try again.", "warning");
                  } else {
                    if (response.data) {
                      toast.success("Added Successfully", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                      });
                    }
                    if (this.props.isSpecial) {
                      dispatch(getSpecialAccessUsersList(searchData));
                    } else {
                      dispatch(getMMPLUsersList(searchData));
                    }
                    this.hideSidePanel();
                    dispatch({
                      type: "PostUserSuccess",
                      data: response.data,
                    });
                  }
                })
                .catch((error) => {
                  swal("Error!", "Something went wrong. Please try again.", "warning");
                  dispatch({
                    type: "PostUserFailure",
                    data: "error",
                  });
                });
            } else if (response.data === false) {
              swal(
                "Error!",
                "User already exist. Please change the email",
                "warning"
              );
              this.setState({ emailId: "" });
            }
            dispatch({
              type: "getUserExistListSuccess",
              data: response.data,
            });
          })
          .catch((error) => {

            dispatch({
              type: "getUserExistListFailure",
              data: "error",
            });
          });
      }
      else {
        swal("Error!", "Invalid email format", "warning");
      }
    } else {
      swal("Error!", "Email is mandatory", "warning");
      //    this.hideSidePanel();
    }
  }

  hideSidePanel = () => {
    if (this.props.isSpecial) {
      this.props.history.push(`/Home/Management/SpecialAccessUser`);
    } else {
      this.props.history.push(`/Home/Management/User`);
    }
  };

  onSelectChange(item) {
    this.state.ships = item;
    this.setState({});
  }

  onRemoveChange(item) {
    this.state.ships = item;
    this.setState({});
  }

  BacktoPrevious() {
    this.props.history.goBack();
  }

  render() {
    const { ShipNameList } = this.props;
    let ScreenWidth = window.innerWidth;
    console.log("width", ShipNameList);
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row px-3 pb-3">
            <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
              onClick={() => this.BacktoPrevious()}
            >
              <div style={{ position: 'relative' }}>
                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
              </div>
            </button>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="panel-box">
                <div
                  className="card MM-card-header mb-0"
                  style={{ backgroundColor: "white", border: "0px" }}
                >
                  <div className="card-body">
                    <h5
                      className="card-title ml-4 mt-2"
                      style={{ color: "092a51" }}
                    >
                      Add User
                    </h5>
                  </div>
                </div>
                <div className="search-filter-box">
                  <div className="row">
                    <div className="col-lg-4">
                      <label className="form-label">Email<span className="mandatory">*</span></label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name="emailId"
                        placeholder="Email"
                        value={this.state.emailId}
                        onChange={(e) => this.handleInputChange(e)}
                      ></input>
                    </div>
                    {!this.props.hideAdmin && (<div className="col-lg-2">
                      <label className="form-label">Is Admin</label>
                      <br></br>
                      <div className="d-flex align-items-center">
                        <input
                          style={{ height: '20px', width: '20px' }}
                          type="checkbox"
                          name="isAdmin"
                          id="adminyes"
                          className="mr-2"
                          checked={this.state.isAdmin}
                          onChange={(e) => this.handleCheckBoxChange(e)}
                        ></input>
                        <label htmlFor="adminyes" className="form-label mr-3">Yes</label>
                        <input
                          style={{ height: '20px', width: '20px' }}
                          type="checkbox"
                          name="isAdminno"
                          id="adminno"
                          className="mr-2"
                          checked={!this.state.isAdmin}
                          onChange={(e) => this.handleCheckBoxChange1(e)}
                        ></input>
                        <label htmlFor="adminno" className="form-label">No</label>
                      </div>
                    </div>)}
                    {!this.state.isAdmin ?
                      <div className="col-lg-6">
                        <label className="form-label">Ship Name</label>
                        <br></br>
                        <Multiselect
                          options={ShipNameList}
                          //   isObject={false}
                          displayValue="shipName"
                          style={{
                            option: {
                              "margin-right": 0,
                              display: "block",
                              "font-weight": "normal",
                            },
                            chips: { "background-color": "#1a3464" },
                          }}
                          onSelect={(item) => this.onSelectChange(item)}
                          onRemove={(item) => this.onRemoveChange(item)}
                          //selectedValues={this.state.ships}
                          placeholder={
                            this.state.ships && this.state.ships.length
                              ? ""
                              : "Select"
                          }
                          closeIcon="cancel"
                        />
                      </div> : null}
                  </div>
                  <div className="row py-3">
                    <div className="col-lg-12">
                      <div className="search-btn-col" style={{ textAlign: "end" }}>
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.SubmitData()}
                        >
                          {" "}
                          Submit{" "}
                        </button>
                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                          type="button"
                          onClick={() => this.hideSidePanel()}
                        >
                          {" "}
                          Cancel{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="row py-3">
                  <div className="col-lg-12">
                    <div className="search-btn-col" style={{ textAlign: "end" }}>
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.SubmitData()}
                      >
                        {" "}
                        Submit{" "}
                      </button>
                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button"
                        onClick={() => this.hideSidePanel()}
                      >
                        {" "}
                        Cancel{" "}
                      </button>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    ShipNameList: state.UserManageReducer.ShipNameList,
    UsersList: state.UserManageReducer.UsersList,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddUser)
);
